<form #referencesForm="ngForm">
  <hw-flex-editable-table
    #referencesTable
    header="mdm.obs-def-02.references.header"
    [form]="referencesForm"
    [data]="definition.references"
    [rowInstance]="defaultReferenceRow"
    [editMode]="editMode">
    <hw-flex-editable-column title="mdm.obs-def-02.references.definition" name="definition" [span]="2">
      <ng-template #viewTemplate let-reference>
        {{ reference.definitionReference?.names | localName }}
      </ng-template>

      <ng-template #editTemplate let-reference>
        <hw-observation-definition-select
          name="definition"
          [(ngModel)]="reference.definitionReference"
          required></hw-observation-definition-select>
      </ng-template>
    </hw-flex-editable-column>

    <hw-flex-editable-column title="Code" name="calculatedField" [columnVisibile]="['view']">
      <ng-template #viewTemplate let-reference>
        <a
          *ngIf="reference.definitionReference"
          [routerLink]="['/observation-definitions/edit', reference.definitionReference?.id]">
          {{ reference.definitionReference?.code }}
        </a>
      </ng-template>
    </hw-flex-editable-column>

    <hw-flex-editable-column
      title="mdm.obs-def-02.references.validate-child-intervals"
      name="validateChildren"
      textAlign="center">
      <ng-template #viewTemplate let-reference>
        <label
          nz-checkbox
          disabled
          [(ngModel)]="reference.validateIntervals"
          [ngModelOptions]="{ standalone: true }"></label>
      </ng-template>
      <ng-template #editTemplate let-reference>
        <label nz-checkbox name="validateChildren" [(ngModel)]="reference.validateIntervals"></label>
      </ng-template>
    </hw-flex-editable-column>

    <hw-flex-editable-column title="mdm.obs-def-02.references.ordering" name="ordering">
      <ng-template #viewTemplate let-reference>
        {{ reference.ordering }}
      </ng-template>
      <ng-template #editTemplate let-reference>
        <hw-input-number [min]="0" name="ordering" [(ngModel)]="reference.ordering"></hw-input-number>
      </ng-template>
    </hw-flex-editable-column>
  </hw-flex-editable-table>
</form>
